'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { 
  initializeAmplitude, 
  setupClickTracking, 
  setupVisibilityTracking, 
  trackSessionStart,
  trackPageView,
  testAmplitudeConnection
} from '@/lib/analytics';

export function AnalyticsProvider({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  useEffect(() => {
    // Initialize Amplitude once when the app loads
    initializeAmplitude();
    
    // Track initial session
    trackSessionStart();
    
    // Test connection in development
    if (process.env.NODE_ENV === 'development') {
      setTimeout(() => {
        testAmplitudeConnection();
      }, 2000); // Wait 2 seconds after initialization
    }
    
    // Set up global tracking
    const cleanupClick = setupClickTracking();
    const cleanupVisibility = setupVisibilityTracking();
    
    // Cleanup function
    return () => {
      cleanupClick?.();
      cleanupVisibility?.();
    };
  }, []); // Only run once on mount

  useEffect(() => {
    // Track page views on route changes
    trackPageView(pathname);
  }, [pathname]);

  return <>{children}</>;
} 